<template>
  <v-col cols="12" sm="6" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar
        color="white"
        flat
        :class="{ 'cta-blurred-card': isCallToActionWidget }"
      >
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Leads Sent by Status</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container
        class="pa-0"
        fluid
        :class="{ 'cta-blurred-card': isCallToActionWidget }"
      >
        <v-row v-if="loading && !isCallToActionWidget">
          <v-col class="mt-12 pt-12 d-flex align-center justify-center">
            <div class="dashboard-widget-progress-container">
              <v-progress-circular
                :size="75"
                :width="8"
                class="my-auto"
                color="primary"
                indeterminate
              />
            </div>
          </v-col>
        </v-row>
        <v-row v-else-if="!loading && summary.length === 0">
          <v-col>
            <v-sheet
              class="mx-auto mt-12 pt-12"
              color="white"
              height="400"
              item
              width="100%"
            >
              <v-row column align="center" justify="center" wrap fill-height>
                <v-avatar color="primary" size="120">
                  <v-avatar color="white" size="110">
                    <v-icon color="primary" size="60">
                      fas fa-chart-line
                    </v-icon>
                  </v-avatar>
                </v-avatar>
              </v-row>
              <v-row align="center" justify="center">
                <span class="font-weight-light body-1 mt-4">
                  No statuses are available at this time.
                </span>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
        <v-list v-else class="mb-2" dense>
          <v-list-item
            v-for="item in summary"
            :key="item.status"
            @click="statusClick(item)"
          >
            <v-row>
              <v-col class="align-self-center">
                <v-list-item-title
                  v-text="item.title"
                  class="font-weight-light pl-2 leads-by-status-text"
                />
              </v-col>

              <v-col>
                <v-list-item-action class="text-right justify-end">
                  <span
                    class="pr-4 funnel-count text-h6 leads-by-status-data"
                    >{{ item.count }}</span
                  >
                </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-container>

      <overview-call-to-action-widget
        v-if="isCallToActionWidget"
        :cta-text="ctaText"
        :title="dialogTitle"
        :description="dialogDescription"
        class="call-to-action-widget"
      />
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
// import { formatters } from "@/mixins/formatters";
import api from "@/services/api.js";
import OverviewCallToActionWidget from "@/components/console/dashboard/OverviewCallToActionWidget";
import C from "@/utils/constants";
import useFormatters from "@/mixins/formatters";

export default {
  name: "console-overview-leads-by-status",
  // mixins: [formatters],
  components: { OverviewCallToActionWidget },
  props: {
    isCallToActionWidget: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      dialogTitle: "",
      dialogDescription: "",
      ctaText: "",
      loading: false,
      summary: [],
      toolTip: null,
      toolTipDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
  },
  methods: {
    ...useFormatters(),
    async loadStats() {
      const excludedStatus = [
        "TRANSFERRED_TO_IBUYER",
        "TRANSFERRED_TO_LENDER",
        "TRANSFERRED_TO_LENDER_INCOMPLETE",
      ];

      this.loading = true;
      this.summary = [];
      let brokerage = this.myBrokerage;
      if (this.impBrokerage !== null) {
        brokerage = this.impBrokerage;
      }

      if (brokerage && brokerage.id) {
        try {
          let { data } = await api.interviews.getOpportunityStatusStats(
            brokerage.id,
          );

          this.summary = data
            .map((d) => {
              return { ...d, title: this.prettyPrintEnum(d.status) };
            })
            .filter((d) => {
              return !excludedStatus.includes(d.status);
            });

          console.log("summary", this.summary);
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
    statusClick(status) {
      this.$router.push({
        name: "my-leads",
        query: {
          status: status.status,
        },
      });
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewLeadsByStatusToolTip");
    },
  },
  mounted() {
    if (this.isCallToActionWidget) {
      this.ctaText = C.LEADS_BY_STATUS_CTA_TEXT;
      this.summary = [...C.LEADS_BY_STATUS_DUMMY_DATA];
      this.dialogTitle = "Leads By Status";
      this.dialogDescription = C.LEADS_BY_STATUS_CTA_DESCRIPTION;
    } else {
      this.loadStats();
    }
  },
};
</script>

<style scoped>
.leads-by-status-text {
  font-size: 14px !important;
}
.leads-by-status-data {
  color: black;
}

.call-to-action-widget {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.cta-blurred-card {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  filter: blur(4px);
  opacity: 0.7;
  pointer-events: none;
}
/*See ConsoleOverview for non-scoped classes*/
</style>
